import Video1 from './Video1'
export default Video1
